<script setup lang="ts">
import ContentContainer from '@/components/layout/ContentContainer.vue';
</script>

<template>
  <ContentContainer class="articleAttribution">
    <slot />
  </ContentContainer>
</template>

<style lang="scss" scoped>
@use "@/assets/styles/shared/screen" as screen;

.articleAttribution {
  border-top: 0.05rem solid #000;
  border-bottom: 0.05rem solid #000;
  background-color: var(--colour-light-warm-grey);
  margin-top: -0.1rem;

  :deep(.content-container) {
    padding-top: var(--spacing-m);
    padding-bottom: var(--spacing-m);
  }

  @include screen.respond(tablet) {
    margin-bottom: 0;
  }
}
</style>
